import { jurisdictionMap, liabilityMap, releaseEventsMap, legalContextMap } from 'src/containers/Escrow/Agreement';
import { LiabilityEnum, ProtectionPeriodEnum } from 'src/graphql/schema';
import { protectionPeriodOptionsDictionary } from 'src/containers/ContinuityEscrow/Agreement';

export type IAgreementField =
  | 'context'
  | 'otherContext'
  | 'conditions'
  | 'conditionsOther'
  | 'jurisdiction'
  | 'liability'
  | 'protectionPeriod';

export const getAgreementSuggestedChangesItems = <K extends IAgreementField, V extends string | string[]>(
  key: K,
  value: V,
) => {
  const keyToMessage = {
    context: {
      label: 'Legal context updated',
      value: Array.isArray(value)
        ? value
            .map((v) => legalContextMap[v as keyof typeof legalContextMap]?.title)
            .filter(Boolean)
            .join(', ')
        : '',
    },
    otherContext: {
      label: 'Custom legal context updated',
      value: value + ' agreement',
    },
    conditions: {
      label: 'Disruption events updated',
      value: Array.isArray(value)
        ? value
            .map((v) => releaseEventsMap[v as keyof typeof releaseEventsMap]?.title)
            .filter(Boolean)
            .join(', ')
        : '',
    },
    conditionsOther: {
      label: 'Custom disruption events updated',
      value: value,
    },
    jurisdiction: {
      label: 'Jurisdiction updated',
      value: jurisdictionMap[value as keyof typeof jurisdictionMap] ?? '',
    },
    liability: {
      label: 'Liability limit updated',
      value: liabilityMap[value as keyof typeof liabilityMap] ?? '',
      ...(value !== LiabilityEnum.Total_0 && { badge: { label: 'Add-on', variant: 'default' } }),
    },
    protectionPeriod: {
      label: 'Continuity protection period updated',
      value: protectionPeriodOptionsDictionary[value as keyof typeof protectionPeriodOptionsDictionary] ?? '',
      ...(value !== ProtectionPeriodEnum.M_3 && { badge: { label: 'Add-on', variant: 'default' } }),
    },
  };

  return key in keyToMessage
    ? (keyToMessage[key] as { label: string; value: string; badge?: { label: string; variant: 'default' } })
    : { label: '', value: '' };
};
